// Global packages and components
import { Checkbox, SidebarFilter } from '~/components'
import { getCustomFilterLabel } from '~/utils'

// Types
import type { BrendaSearchFilter, FilterLabel } from '~/types'

interface Props {
  filters: BrendaSearchFilter[]
  attributes: string[]
  priceRange?: string | null
  filterLabels?: FilterLabel[]
  setQueryAttributes: (e: string) => void
}

// Main export
const AttributeFilters = ({
  filters,
  filterLabels,
  attributes,
  setQueryAttributes,
}: Props) =>
  filters.map((filter, fi) => (
    <div key={fi}>
      <SidebarFilter
        label={filter.label}
        defaultOpen={fi < 3 ? true : false}
      >
        {filter?.options?.map((option, oi) => {
          const urlFilter = encodeURI(filter.key + '|' + option.value)
          const customLabel = getCustomFilterLabel(
            filter.key,
            option.value,
            filterLabels
          )

          return (
            <div
              className="mb-3"
              key={oi}
            >
              <Checkbox
                id={`filter-${urlFilter}`}
                label={customLabel ?? option.value}
                checked={attributes.some(e => e == urlFilter)}
                onChange={() => setQueryAttributes(urlFilter)}
              />
            </div>
          )
        })}
      </SidebarFilter>
    </div>
  ))

export default AttributeFilters
